"use client";

/* 通用地址选择-抽屉弹层 */
// React
import React from 'react';
// 接口
import { Address } from "@/apis/address/address.interface";
// 组件
import Drawer from '@mui/material/Drawer';
import AddressSelectContent from './AddressSelectContent';

interface IProps {
  openDrawer: boolean;
  width?: string | number;
  defaultShippingType?: "delivery" | "pickup"; // 默认选中的配送类型 不传默认delivery
  availableShippingTypes?: ("delivery" | "pickup")[]; // 可用的配送类型 不传默认展示delivery+pickup
  defaultPickupTypeTab?: "recommended" | "saved";
  availablePickupTypes?: ("recommended" | "saved")[];
  selectAddressId?: string | number; // 选中的地址id 如果未传shippingType则默认delivery
  canSwitchSite?: boolean; // 是否可以切换站点 默认可以切换
  canSwitchCountry?: boolean; // 是否可以切换国家 默认可以切换
  isFrigNeed?: boolean; // 是否需要冷藏冷冻
  showManage?: boolean; // 是否展示地址管理按钮
  pickupExtMap?: Record<string, any>; // 自提查询扩展参数
  setOpenDrawer: (val: boolean) => void; // drawer模式下 需要传入抽屉开启/关闭方法
  onAddressApply?: (address: Address) => void; // 支持传入回调函数 当地址选择变化时触发 如果传入此属性 则地址选择组件不处理任何写逻辑 均由父组件处理
}

const AddressSelectDrawer: React.FC<IProps> = ({ 
  openDrawer, 
  width = "480px",
  defaultShippingType, 
  availableShippingTypes, 
  defaultPickupTypeTab,
  availablePickupTypes,
  selectAddressId, 
  canSwitchSite, 
  canSwitchCountry,
  isFrigNeed,
  showManage,
  pickupExtMap,
  setOpenDrawer, 
  onAddressApply 
}) => {

  return (
    <Drawer
      anchor="right"
      open={openDrawer}
      onClose={() => setOpenDrawer(false)}
      sx={{
        '& .MuiDrawer-paper': {
          width: width,
        },
      }}
    >
      <AddressSelectContent
        mode='drawer'
        defaultShippingType={defaultShippingType}
        availableShippingTypes={availableShippingTypes}
        defaultPickupTypeTab={defaultPickupTypeTab}
        availablePickupTypes={availablePickupTypes}
        selectAddressId={selectAddressId}
        canSwitchSite={canSwitchSite}
        canSwitchCountry={canSwitchCountry}
        isFrigNeed={isFrigNeed}
        showManage={showManage}
        pickupExtMap={pickupExtMap}
        setOpenDrawer={setOpenDrawer}
        onAddressApply={onAddressApply}
      />
    </Drawer>
  )
};

export default AddressSelectDrawer
